<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页</div>
      <!--      <div class="curse-btn" @click="to(`/formsub`)">添加项目</div>-->
    </div>
    <div class="list-content">
      <div class="sumlist">
        <div class="item">
          <div class="tit">机构</div>
          <div class="nums">{{organ.login}}</div>
          <div class="tex">2025年登录机构数量</div>
        </div>
        <div class="item">
          <div class="tit">机构</div>
          <div class="nums">{{ organ.new }}</div>
          <div class="tex">2026年新增机构数量</div>
        </div>
        <div class="item">
          <div class="tit">机构</div>
          <div class="nums">{{ organ.phone }}</div>
          <div class="tex">绑定手机号机构数量</div>
        </div>
      </div>
      <div class="titbig">2025年</div>
      <div class="sumlist old">
        <div class="item">
          <div class="tit">机构</div>
          <div class="nums">896</div>
          <div class="tex">申报机构数量</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">1280</div>
          <div class="tex">申报项目数量</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">1098</div>
          <div class="tex">初审通过数量</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">28</div>
          <div class="tex">终审通过数量</div>
        </div>
      </div>
      <div class="titbig">2026年</div>
      <div class="sumlist old">
        <div class="item">
          <div class="tit">机构</div>
          <div class="nums">{{ organ.total }}</div>
          <div class="tex">机构总数</div>
        </div>
        <div class="item">
          <div class="tit">机构</div>
          <div class="nums">{{ organ.new }}</div>
          <div class="tex">新增机构数量</div>
        </div>
        <div class="item">
          <div class="tit">机构</div>
          <div class="nums">{{ organ.today }}</div>
          <div class="tex">今日新增</div>
        </div>
        <div class="item">
          <div class="tit">机构</div>
          <div class="nums">{{ organ.yesterday }}</div>
          <div class="tex">昨日新增</div>
        </div>
      </div>

      <div class="sumlist">
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ total.total }}</div>
          <div class="tex">申报总数</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ total.today }}</div>
          <div class="tex">今日新增</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ total.yesterday }}</div>
          <div class="tex">昨日新增</div>
        </div>
      </div>

      <div class="sumlist">
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ approve.total }}</div>
          <div class="tex">待审核总数</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ approve.today }}</div>
          <div class="tex">今日待审核</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ approve.yesterday }}</div>
          <div class="tex">昨日待审核</div>
        </div>
      </div>

      <div class="sumlist">
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ pass.total }}</div>
          <div class="tex">已审核总数</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ pass.today }}</div>
          <div class="tex">今日已审核</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ pass.yesterday }}</div>
          <div class="tex">昨日已审核</div>
        </div>
      </div>

      <div class="sumlist">
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ refund.total }}</div>
          <div class="tex">已驳回总数</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ refund.today }}</div>
          <div class="tex">今日已驳回</div>
        </div>
        <div class="item">
          <div class="title">申报</div>
          <div class="num">{{ refund.yesterday }}</div>
          <div class="tex">昨日已驳回</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { zhDate } from "@/tools";
import { baseURL } from "@/config";
import { index } from "@/api/admin";

export default {
  name: "index",
  data() {
    return {
      zhDate: zhDate,
      baseURL: baseURL,
      organ: {
        total: 0,
        today: 0,
        yesterday: 0,
      },
      total: {
        total: 0,
        today: 0,
        yesterday: 0,
      },
      approve: {
        total: 0,
        today: 0,
        yesterday: 0,
      },
      pass: {
        total: 0,
        today: 0,
        yesterday: 0,
      },
      refund: {
        total: 0,
        today: 0,
        yesterday: 0,
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.shzztoken;
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 0,
    });
    this.init();
  },
  methods: {
    // 获取列表
    async init() {
      let _data = await index();
      if (_data.code === 200) {
        this.organ = _data.data.organ;
        this.total = _data.data.project.total;
        this.approve = _data.data.project.approve;
        this.pass = _data.data.project.pass;
        this.refund = _data.data.project.refund;
      } else {
        this.$message.error(_data.message);
      }
    },

    to(path) {
      this.$router.push(path);
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;
.titbig {
  width: 100%;
  font-size: 30px;
  color: #333333;
  font-weight: bold;
  padding: 10px 0;
}
  .curse-content {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    border-radius: 10px;
    //padding: 20px;
    //background: #ffffff;

    .sumlist {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      &.old {
        .item {
          width: 24.7%;
        }
      }

      .item {
        width: 33%;
        background: #ffffff;
        box-shadow: #d7d0d0 0px 0px 6px;
        border-radius: 5px;
        height: 180px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: relative;
        .tit {
          position: absolute;
          top: 5px;
          left: 5px;
          width: 60px;
          height: 30px;
          background: #fcead1;
          text-align: center;
          line-height: 30px;
          border-radius: 4px;
          font-size: 16px;
          color: #e89323;
          font-weight: bold;
        }

        .title {
          position: absolute;
          top: 5px;
          left: 5px;
          width: 60px;
          height: 30px;
          background: #d5e1ff;
          text-align: center;
          line-height: 30px;
          border-radius: 4px;
          font-size: 16px;
          color: #1546c5;
          font-weight: bold;
        }

        .nums {
          width: 100%;
          text-align: center;
          font-size: 40px;
          font-weight: bold;
          color: #e89323;
        }

        .num {
          width: 100%;
          text-align: center;
          font-size: 40px;
          font-weight: bold;
          color: #1546c5;
        }

        .tex {
          width: 100%;
          text-align: center;
          font-size: 18px;
          color: #666666;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
